import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from './constants';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  serviceURL = "/v1/Admin/";

  constructor(private http: HttpClient) { }

  getEventExclusionList() {
    
    const url = Constants.baseURL + this.serviceURL + 'GetEventExclusionList';
    return this.http.get(url);
  }

  getCurrentEventList() {
    
    const url = Constants.baseURL + this.serviceURL + 'GetCurrentEventList';
    return this.http.get(url);
  }

  addEventToExclusionList(id){
    const url = Constants.baseURL + this.serviceURL + 'AddEventToExclusionList/' + id;
    return this.http.post(url,{});
  }

  removeEventFromExclusionList(id){
    const url = Constants.baseURL + this.serviceURL + 'RemoveEventFromExclusionList/' + id;
    return this.http.post(url,{});
  }
}
